/*
 * Admin area to edit cancel action button labels.  Each label per touchpoint is shown in a list broken down by language.
 */

define([
  "marionette",
  "messaging/messenger",
  "./cancelActionLabelsView",
  "./touchPointSelectDisplay/touchPointSelectDisplayModule",
  "./cancelActionLabelDisplay/cancelActionLabelDisplayModule",
  "./cancelActionLabelsModel",
], function (
  Marionette,
  Messenger,
  CancelActionLabelsView,
  TouchPointSelectDisplayModule,
  CancelActionLabelDisplayModule,
) {
  var CancelActionLabelsController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "cancelActionLabels";
      this.region = options.region;
      this.kb = options.model;
      this._setUpVents();
    },
    show: function () {
      this.layout = new CancelActionLabelsView.cancelActionLabelsLayout();
      this.touchPointSelectDisplayModule = this.addSubModule(
        new TouchPointSelectDisplayModule({ region: this.layout.touchPointSelect }),
      );
      this.cancelActionLabelDisplayModule = this.addSubModule(
        new CancelActionLabelDisplayModule({ region: this.layout.cancelActionLabelDisplay }),
      );

      this.defaultTouchPoint = Messenger.reqres.request("default:touchpoint");
      this.touchPoints = this.kb.getTouchPoints();

      this.layout.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );
      this.showRegion(this.layout);
    },
    _showSubViews: function () {
      this.cancelActionLabelDisplayModule.show(this.defaultTouchPoint);
      this.touchPoints.onSynced(function () {
        this.touchPointSelectDisplayModule.show(this.touchPoints, this.defaultTouchPoint);
      }, this);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "show:kb:admin:cancelActionLabels",
        function () {
          this.show();
        },
        this,
      );
      Messenger.vent.on(
        "show:kb:profile:cancelActionLabels",
        function () {
          this.show();
        },
        this,
      );
      Messenger.vent.on(
        "refresh:kb:response:settings",
        function (updatedKb) {
          this.kb = updatedKb;
        },
        this,
      );
    },
  });

  return CancelActionLabelsController;
});
